import { useUserStore } from '~~/stores/useUserStore'
import type { Role } from '~/composables/usePermissions'
import { groupPathToLabel } from '~/utils/worksCouncil'

// Highest responsibility first. The first role the user holds is shown as the position.
const ROLE_PRIORITY: Role[] = [
  'CHIEF_EXECUTIVE_OFFICER',
  'HEAD_OF_WORKS_COUNCIL',
  'WORKS_COUNCIL',
  'HUMAN_RESOURCES',
  'IT_DEPARTMENT',
  'BUSINESS_DEPARTMENT',
  'EMPLOYEE'
]

export function useUserIdentity() {
  const { t: $t } = useI18n()
  const userStore = useUserStore()
  const { organization, groups } = storeToRefs(userStore)
  const { userRoles } = usePermissions()

  const displayName = computed(() => userStore.user?.name ?? $t('user.unknown'))

  const sortedRoles = computed(() => ROLE_PRIORITY.filter((role) => userRoles.value.includes(role)))

  const roleLabels = computed(() => sortedRoles.value.map((role) => $t(`user.role.${role}`)))

  const primaryRoleLabel = computed(() => roleLabels.value[0] ?? null)

  const organizationName = computed(() => organization.value?.name ?? null)

  const worksCouncilLabels = computed(() => groups.value.map(groupPathToLabel))

  return { displayName, primaryRoleLabel, roleLabels, organizationName, worksCouncilLabels }
}
